import React from "react";
import BookingsOverview from "./bookings/BookingsOverview";
import "../styles/MatchBooking.css";

const MatchBooking = ({ onMatchSlotConfirm, onCancel, tournamentCourtGroupId, tournamentName }) => {
    return (
        <div className="match-booking-container">
            <div className="match-booking-header">
                <h3>Platz und Zeit für das Match auswählen</h3>
                <p>Wähle einen freien Slot in der Kalenderansicht aus. Die Dauer kann in 30-Minuten-Schritten angepasst werden.</p>
                {tournamentName && (
                    <p style={{marginTop: 8, fontSize: 14, color: "#555"}}>
                        Turnier: <strong>{tournamentName}</strong>
                    </p>
                )}
            </div>

            <BookingsOverview
                isMatchBookingMode={true}
                onMatchSlotConfirm={onMatchSlotConfirm}
                onMatchSlotCancel={onCancel}
                tournamentCourtGroupId={tournamentCourtGroupId}
            />
        </div>
    );
};

export default MatchBooking;
